// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2eqW_","topBottomGutter":"Layout_topBottomGutter__3qxAe"};